import type { CrremPathwayScale } from "../model/types";

import { CRREM_PATHWAY_SCALE } from "../model/constants";

export const resolveAreaDivisor = (
  scale: CrremPathwayScale,
  areas: { grossArea?: number; netLettableArea?: number }
) => {
  if (scale === CRREM_PATHWAY_SCALE.grossArea) return areas.grossArea;
  if (scale === CRREM_PATHWAY_SCALE.netLettableArea) return areas.netLettableArea;
  return undefined;
};

export const scaleChartValue = (value: number, divisor?: number, multiplier?: number) => {
  const absolute = multiplier === undefined ? value : value * multiplier;
  if (divisor === undefined) return absolute;
  return absolute / divisor;
};
